function getWindow() {
    return window;
}
var WindowRefService = /** @class */ (function () {
    function WindowRefService() {
    }
    Object.defineProperty(WindowRefService.prototype, "nativeWindow", {
        get: function () {
            return getWindow();
        },
        enumerable: true,
        configurable: true
    });
    WindowRefService.prototype.getHref = function () {
        var w;
        w = getWindow();
        return w.location.href;
    };
    return WindowRefService;
}());
export { WindowRefService };
